// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root___T4kF","inputWrap":"CustomTip_inputWrap__3Mo3H"};